import { render, staticRenderFns } from "./Particulars.vue?vue&type=template&id=796b9156&scoped=true&"
import script from "./Particulars.vue?vue&type=script&lang=js&"
export * from "./Particulars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796b9156",
  null
  
)

export default component.exports